<template>
    <v-container flat>
        <v-row no-gutters cols="12" class="my-3 justify-center">
            <v-col cols="2">
                <v-btn-primary
                    block
                    @click="createBankAccountDialog = true"
                    :disabled="!currentUser.profile.configuration.bankAccount.write"
                    data-cy="Bank-add"
                >
                    Ajouter
                </v-btn-primary>
            </v-col>
            <v-col cols="8" class="pl-2">
                <!-- <v-text-field
                    v-model="search"
                    label="Recherche"
                    outlined
                    hide-details dense
                ></v-text-field> -->
            </v-col>
            <v-col cols="2" class="pl-2">
                <v-btn-primary
                    block
                    :disabled="
                        bankAccountsToMerge.length < 2 ||
                        !currentUser.profile.configuration.bankAccount.write
                    "
                    @click="mergeBankAccountDialog = true"
                    data-cy="Bank-merge"
                >
                    Fusionner
                </v-btn-primary>
            </v-col>
        </v-row>
        <v-row
            class="d-flex justify-center"
            :style="'max-height:' + maxHeight + ';' + 'overflow:auto'"
        >
            <v-col
                :cols="$vuetify.display.mobile ? '12' : '10'"
                class="my-0 pa-2"
                v-for="(account, i) in bankAccounts"
                :disabled="isMergeDisabled(account)"
                :key="i + account.id"
            >
                <v-card
                    data-cy="BankAccount-Card"
                    class="default_card ma-0 pa-4"
                    elevation="0"
                    :disabled="isMergeDisabled(account)"
                    pa-0
                >
                    <v-row>
                        <v-col cols="2" v-if="!$vuetify.display.mobile">
                            <!-- <v-icon color="secondary"  size=“x-large” class="icon ma-1">
                                $fa-university
                            </v-icon> -->
                            <v-checkbox
                                :disabled="isMergeDisabled(account)"
                                :key="i + account.id"
                                class="d-flex justify-center align-center pa-0 ma-0"
                                @click.stop="selectBankAccount(account)"
                                :value="isSelectedBankAccount(account)"
                            />
                        </v-col>
                        <v-col :cols="$vuetify.display.mobile ? '8' : '6'">
                            <div class="d-flex align-center primary--text justify-space-between">
                                <span
                                    :class="$vuetify.display.mobile ? 'ml-2' : ''"
                                    style="font-weight: bold; font-size: 16pt"
                                >
                                    {{ getBankAccountName(account) }}
                                </span>
                            </div>
                            <div
                                class="d-flex align-center justify-space-between"
                                v-if="account.number"
                            >
                                Numéro : {{ account.number }}
                            </div>
                            <div
                                class="d-flex align-center justify-space-between"
                                v-if="account.iban && !account.iban.startsWith(account.name)"
                            >
                                IBAN : {{ account.iban }}
                            </div>
                            <div
                                class="d-flex align-center justify-space-between"
                                v-if="account.externalName"
                            >
                                Nom externe : {{ account.externalName }}
                            </div>
                            <div>
                                <v-icon size="x-small" class="mr-2">$fa-upload</v-icon
                                >{{ getOrigin(account) }}
                                {{ " - " + account.bankTransactionCount + " transaction(s)" }}
                            </div>
                            <div v-if="account.importStartDate">
                                <v-icon size="x-small" class="mr-2">$fa-upload</v-icon>Date de
                                reprise : {{ formatDate(account.importStartDate) }}
                                {{
                                    " - " +
                                    account.beforeImportStartDateBTCount +
                                    " transaction(s) avant"
                                }}
                            </div>
                            <div
                                style="color: #f76631"
                                v-if="account.currentError && account.currentError.length > 0"
                            >
                                {{ account.currentError }}
                            </div>
                            <div v-if="!account.bic" class="d-flex pt-2">
                                <v-icon class="mr-2 mb-1" color="red" size="small">
                                    $oss-warning
                                </v-icon>
                                <h4 style="color: red; font-weight: normal">BIC manquant</h4>
                            </div>
                        </v-col>
                        <v-col cols="4" class="py-1">
                            <v-row no-gutters class="fill-height">
                                <v-col cols="12" class="d-flex justify-end">
                                    <v-menu location="start">
                                        <template v-slot:activator="{ props }">
                                            <v-btn-icon
                                                data-cy="BankAccount-options"
                                                icon="$dots_vertical"
                                                v-bind="props"
                                            />
                                        </template>

                                        <v-list nav density="compact">
                                            <v-list-item
                                                @click="
                                                    selectedBankId = account.id;
                                                    createBankAccountDialog = true;
                                                "
                                            >
                                                <v-list-item-title
                                                    data-cy="BankAccount-options-modification"
                                                >
                                                    Modifier
                                                </v-list-item-title>
                                                <template #append>
                                                    <v-icon size="small" location="start"
                                                        >$oss-edit</v-icon
                                                    >
                                                </template>
                                            </v-list-item>

                                            <v-list-item
                                                v-if="
                                                    account.budgetInsightId &&
                                                    account.type !== 'CASH_BOX'
                                                "
                                                :disabled="
                                                    !currentUser.profile.configuration.bankAccount
                                                        .write
                                                "
                                                @click="
                                                    toDisconnectBankAccount = account;
                                                    disconnectBankAccountDialog = true;
                                                "
                                            >
                                                <v-list-item-title> Déconnexion </v-list-item-title>
                                                <v-list-item-action class="d-flex align-center">
                                                    <v-icon size="small" left>$link_off</v-icon>
                                                </v-list-item-action>
                                            </v-list-item>

                                            <v-list-item
                                                :disabled="
                                                    !currentUser.profile.configuration.bankAccount
                                                        .delete
                                                "
                                                @click="
                                                    toDeleteBankAccount = account;
                                                    deleteBankAccountDialog = true;
                                                "
                                            >
                                                <v-list-item-title
                                                    data-cy="BankAccount-options-delete"
                                                >
                                                    Supprimer
                                                </v-list-item-title>
                                                <template #append>
                                                    <v-icon size="small" location="start"
                                                        >$oss-trash</v-icon
                                                    >
                                                </template>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </v-col>
                                <!-- <v-col
                                    cols="12"
                                    class="d-flex align-center justify-center mx-0 px-0 py-1"
                                >
                                    <v-btn
                                         size="small"
                                        rounded

                                        elevation="0"
                                        color="secondary"
                                        @click="
                                            selectedBankId = account.id;
                                            createBankAccountDialog = true;
                                        "
                                        :loading="loading"
                                    >
                                        Modifier<v-icon  size="small" right>$edit</v-icon>
                                    </v-btn>
                                </v-col> -->
                                <v-col
                                    cols="12"
                                    class="d-flex align-center justify-center mx-0 px-0 py-1"
                                    v-if="account.budgetInsightId"
                                >
                                    <v-btn
                                        :disabled="!enableBudgetInsight(account)"
                                        rounded
                                        elevation="0"
                                        color="new_red"
                                        @click="connectClicked"
                                        :loading="loading"
                                        size="small"
                                    >
                                        {{ account.currentError ? "Réparer" : "Configuration" }}
                                        <v-icon size="small" location="end">$build</v-icon>
                                    </v-btn>
                                </v-col>
                                <!-- <v-col
                                    cols="12"
                                    class="d-flex align-center justify-center mx-0 px-0 py-1"
                                    v-if="account.budgetInsightId && account.type !== 'CASH_BOX'"
                                >
                                    <v-btn
                                        :disabled="!currentUser.profile.configuration.bankAccount.delete"
                                        color="new_red"
                                        rounded
                                         size="small"

                                        elevation="0"
                                        @click="
                                            toDisconnectBankAccount = account;
                                            disconnectBankAccountDialog = true;
                                        "
                                        >Déconnexion<v-icon  size="small" right>$link_off</v-icon>
                                    </v-btn>
                                </v-col> -->
                                <!-- <v-col
                                    cols="12"
                                    class="d-flex align-center justify-center mx-0 px-0 py-1"
                                    v-if="account.type !== 'CASH_BOX'"
                                >
                                    <v-btn
                                        :disabled="!currentUser.profile.configuration.bankAccount.delete"
                                        color="new_red"
                                        rounded
                                         size="small"

                                        elevation="0"
                                        @click="
                                            toDeleteBankAccount = account;
                                            deleteBankAccountDialog = true;
                                        "
                                        >Suppression<v-icon  size="small" right>$delete</v-icon>
                                    </v-btn>
                                </v-col> -->
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <oss-dialog
            v-model="deleteBankAccountDialog"
            title="Supprimer"
            :error="true"
            :errorTextConfirmation="getBankAccountName(toDeleteBankAccount)"
            @valid="deleteBankAccount"
            :validLoading="deleteBankAccountLoading"
            v-if="deleteBankAccountDialog"
            width="800px"
        >
            <h4 class="mb-2 text-center">
                &#xca;tes-vous sûr(e) de vouloir supprimer le compte bancaire
                {{ getBankAccountName(toDeleteBankAccount) }} ?
            </h4>

            <div v-if="toDeleteBankAccount.bankTransactionCount">
                <v-alert type="error" class="mt-4" :model-value="true" variant="text">
                    Vous supprimerez aussi les
                    {{ toDeleteBankAccount.bankTransactionCount }} transactions associées à ce
                    compte.
                </v-alert>
            </div>
        </oss-dialog>
        <oss-dialog
            v-model="disconnectBankAccountDialog"
            title="Déconnecter un compte bancaire"
            @valid="disconnectBankAccount"
            :validLoading="disconnectBankAccountLoading"
            v-if="disconnectBankAccountDialog"
            width="800px"
        >
            <h4 class="mb-2 text-center">
                &#xca;tes-vous sûr(e) de vouloir arreter la récupération automatique des flux
                bancaires du compte bancaire suivant ?
            </h4>
            <div style="text-align: center">
                {{ getBankAccountName(toDeleteBankAccount) }}
            </div>
        </oss-dialog>
        <CreateBankAccount
            v-model:active="createBankAccountDialog"
            :companyId="companyId"
            :companyBudgetInsightId="budgetInsightId"
            :bankId="selectedBankId"
            :bankAccounts="bankAccounts"
            @refresh="refresh()"
            @closeDialog="closeDialog()"
        />
        <oss-dialog
            v-model="mergeBankAccountDialog"
            v-if="mergeBankAccountDialog"
            title="Fusionner"
            :actions="actions"
            width="40vw"
        >
            <MergeBankAccounts
                :bankAccountsToMerge="bankAccountsToMerge"
                :companyId="companyId"
                :actions="actions"
                @bankAccounts-merged="mergedBankAccounts()"
            />
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { User } from "../../store/store";

import { Apollo } from "@/decorators";
import BANK_ACCOUNTS from "../../graphql/bank/BankAccountsWithBTCount.gql";
import DELETE_BANKACCOUNT from "../../graphql/bank/DeleteBankAccount.gql";
import DISCONNECT_BANKACCOUNT from "../../graphql/bank/DisconnectBankAccount.gql";

import { BankAccount } from "../../../../types";

import { connectBank } from "../../services/bankServices";

import CreateBankAccount from "./CreateBankAccount.vue";
import { DialogAction } from "../../services/dialogAction";
import MergeBankAccounts from "../bank/MergeBankAccounts.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {
        CreateBankAccount,
        MergeBankAccounts,
    },
    emits: ["refresh"],
})
export class Bank extends Vue {
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: null }) budgetInsightId: string;

    deleteBankAccountDialog = false;
    deleteBankAccountLoading = false;
    toDeleteBankAccount = null;

    disconnectBankAccountDialog = false;
    disconnectBankAccountLoading = false;
    toDisconnectBankAccount = null;

    loading = false;

    selectedBankId = "";

    createBankAccountDialog = false;
    // bankAccountName = ""
    // bankAccountIban = ""
    // wizardStep = 1
    // createBankAccountLoading = false

    mergeBankAccountDialog = false;

    bankAccountsToMerge = [];

    actions = {
        action: new DialogAction(),
    };

    get currentUser(): User {
        return this.$store.state.user;
    }

    get maxHeight() {
        const innHeight = window.innerHeight;
        const vhHeight = (180 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }

    enableBudgetInsight(account) {
        return this.currentUser.profile?.configuration.bankAccount?.write;
    }

    @Apollo(
        {
            query: BANK_ACCOUNTS,
            variables() {
                return {
                    companyId: this.companyId,
                    type: "BANK",
                };
            },
            skip() {
                return !this.companyId;
            },
        },
        (data) => (data && data.bankAccounts ? data.bankAccounts : []),
    )
    bankAccounts: BankAccount[] = [];

    getBankAccountName(account) {
        let name = "";
        if (account) {
            if (account.bank && account.bank.name) name = account.bank.name + ": ";
            name += account.name;
            // if (account.bankTransactionCount !== undefined) {
            //     name += " (" + account.bankTransactionCount + ")"
            // }
        }
        return name;
    }

    getOrigin(account) {
        if (account.budgetInsightId) {
            return "Import automatique";
        }
        return "Import manuel";
    }

    async deleteBankAccount() {
        this.deleteBankAccountLoading = true;
        if (this.toDeleteBankAccount) {
            const result = await this.$apollo.mutate({
                mutation: DELETE_BANKACCOUNT,
                variables: {
                    id: this.toDeleteBankAccount.id,
                },
            });
            this.refresh();
        }
        this.toDeleteBankAccount = null;
        this.deleteBankAccountLoading = false;
        this.deleteBankAccountDialog = false;
    }

    async disconnectBankAccount() {
        this.disconnectBankAccountLoading = true;
        if (this.toDisconnectBankAccount) {
            const result = await this.$apollo.mutate({
                mutation: DISCONNECT_BANKACCOUNT,
                variables: {
                    id: this.toDisconnectBankAccount.id,
                },
            });
            this.refresh();
        }
        this.toDisconnectBankAccount = null;
        this.disconnectBankAccountLoading = false;
        this.disconnectBankAccountDialog = false;
    }

    async connectClicked() {
        this.createBankAccountDialog = false;
        this.loading = true;
        await connectBank(this.$apollo, this.companyId);
        this.loading = false;
    }

    // disabledCreateAccount() {
    //     return !this.bankAccountName ||
    //            this.bankAccountName.length < 2 ||
    //            !this.bankAccountIban ||
    //            this.bankAccountIban.length < 27 ||
    //            this.bankAccountIban.length > 34
    // }

    // async createBankAccount() {
    //     this.createBankAccountLoading = true
    //     const result = await this.$apollo.mutate({
    //         mutation: CREATE_BANKACCOUNT,
    //         variables: {
    //             companyId: this.companyId,
    //             name: this.bankAccountName,
    //             iban: this.bankAccountIban
    //         }
    //     });
    //     this.refresh();
    //     this.createBankAccountDialog = false
    //     this.createBankAccountLoading = false
    // }

    // close() {
    //     this.createBankAccountDialog = false
    //     this.createBankAccountLoading = false
    // }

    refresh() {
        this.$emit("refresh");
        if (this.$apollo.queries && this.$apollo.queries.bankAccounts) {
            this.$apollo.queries.bankAccounts.refetch();
        } else {
            debugger;
        }
    }

    closeDialog() {
        this.selectedBankId = "";
        this.refresh();
    }

    formatDate(date) {
        if (!date) return "";
        moment.locale("fr");
        return moment(date).format("DD/MM/YYYY");
    }

    @Watch("bankAccountsToMerge", { deep: true })
    isMergeDisabled(bankAccount) {
        if (this.bankAccountsToMerge.find((account) => account.id === bankAccount.id)) {
            return false;
        }

        if (!this.currentUser.profile.configuration.bankAccount.write) {
            return true;
        }

        if (this.bankAccountsToMerge.length > 1) {
            return true;
        }

        if (this.hasBudgetInsightIdSelected() && bankAccount.budgetInsightId) {
            return true;
        }

        if (bankAccount.iban === "") {
            return false;
        }

        if (
            bankAccount.iban &&
            this.bankAccountsToMerge.some(
                (account) => account.iban && account.iban !== bankAccount.iban,
            )
        ) {
            return true;
        }
        // Sinon, permettre la sélection
        return false;
    }

    selectBankAccount(bankAccount) {
        const isSelected = this.isSelectedBankAccount(bankAccount);
        if (isSelected) {
            this.bankAccountsToMerge = this.bankAccountsToMerge.filter(
                (bA) => bA.id !== bankAccount.id,
            );
        } else {
            this.bankAccountsToMerge.push(bankAccount);
        }
    }

    isSelectedBankAccount(bankAccount) {
        const isSelected = this.bankAccountsToMerge.find((bA) => bA.id === bankAccount.id);
        return isSelected;
    }

    hasBudgetInsightIdSelected() {
        // Vérifie si un compte avec budgetInsightId est déjà sélectionné
        return this.bankAccountsToMerge.some((account) => account.budgetInsightId);
    }

    async mergedBankAccounts() {
        this.mergeBankAccountDialog = false;
        this.bankAccountsToMerge = [];
        this.refresh();
    }
}

export default toNative(Bank);
</script>
